import { render, staticRenderFns } from "./AffiliateStats.vue?vue&type=template&id=2f4a37fe&"
import script from "./AffiliateStats.vue?vue&type=script&lang=js&"
export * from "./AffiliateStats.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateStats.vue?vue&type=style&index=0&id=2f4a37fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports